import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import './PDFModal.css';

const PDFModal = ({ isOpen, onClose, pdfUrl, title }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="pdf-modal-overlay" onClick={handleOverlayClick}>
      <div className="pdf-modal">
        <div className="pdf-modal-header">
          <h3>{title}</h3>
          <div className="pdf-modal-controls">
            <a 
              href={pdfUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-sm btn-secondary"
            >
              {t('pdfModal.download')}
            </a>
            <button 
              className="pdf-modal-close" 
              onClick={onClose}
              aria-label={t('pdfModal.closeModal')}
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>
        <div className="pdf-modal-content">
          <iframe
            src={pdfUrl}
            title={title}
            className="pdf-iframe"
            frameBorder="0"
          />
        </div>
      </div>
    </div>
  );
};

export default PDFModal;